import Button from "@scripts/react/components/Button";
import { TooltipContainer } from "@scripts/react/components/Tooltip";
import { twClassNames } from "@scripts/react/helpers/twClassNames";

interface AddFilesButtonProps {
    onClick: () => void;
    disabled?: boolean;
    hasVideo?: boolean;
}

export function AddFilesButton({
    onClick,
    disabled = false,
    hasVideo = false
}: AddFilesButtonProps) {
    const button = (
        <Button
            type="dark-ghost"
            size="large"
            shape="square"
            onClick={onClick}
            disabled={disabled}
            aria-label="Add files"
            className={twClassNames(
                "group !size-12 shrink-0 border border-dashed !border-white/10 !bg-white/10 !backdrop-blur-none",
                !disabled && "hover:!border-white/40 hover:!bg-white/20"
            )}
        >
            <i
                className={twClassNames(
                    "far fa-plus text-base text-white/70 transition-transform duration-200",
                    !disabled && "group-hover:scale-125"
                )}
            />
        </Button>
    );

    if (disabled) {
        return (
            <TooltipContainer
                type="titleOnly"
                placement="top"
                trigger="mouseenter focus"
                interactive={true}
                title={
                    <span>
                        <strong>
                            {hasVideo
                                ? "You only need 1 video to build a model. "
                                : "You only need 10 images to build a model. "}
                        </strong>
                        <br></br> To label a large amount of data, use our{" "}
                        <a
                            href="https://app.roboflow.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-purboflow-300"
                        >
                            core platform
                        </a>
                        .
                    </span>
                }
                customButton={<div className="inline-block">{button}</div>}
            />
        );
    }

    return (
        <TooltipContainer
            type="titleOnly"
            placement="top"
            title="Add files"
            trigger="mouseenter"
            customButton={<div className="inline-block">{button}</div>}
        />
    );
}
